import { memo } from "react";
import Image from "../../../components/Images/Image";
import logo from "../../../assets/images/clearpath-logo.png";

const headerStyle: React.CSSProperties = {
  height: "80px",
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "var(--clearpath-dark-gray)",
};

const logoStyle: React.CSSProperties = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: "50%",
};

function RegisterHeader() {
  return (
    <div style={headerStyle}>
      <Image src={logo} alt="Clearpath Logo" style={logoStyle} />
    </div>
  );
}

export default memo(RegisterHeader);
